import React from 'react';
import Text from 'components/Core/Text';

const ToggleSwitch = ({ indexSelected, checkedState, titles, handleClick }) => (
  <div className="toggle--switch">
    <input type="checkbox" checked={checkedState} onChange={() => handleClick()} />
    <label>
      <div className="toggle--titles">
        {(titles || []).map((title, index) => {
          const selected = index === indexSelected;
          const color =
            index === indexSelected ? 'var(--blue-primary)' : 'var(--neutral-text-color)';

          return (
            <div className="toggle--title-container" key={`toggle--title-container-${index}`}>
              <Text type="p" size="normal" className="toggle--title" color={color}>
                {title}
              </Text>
            </div>
          );
        })}
      </div>
      <div className="toggle--toggle" />
    </label>
  </div>
);

export default ToggleSwitch;
